import * as React from 'react';
import { Button, IconTrigger, Modal } from '@grandvisionhq/common';
import { Hr } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const PromoteInstallmentsModal = ({ modalBodySlot  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const onModalOpen = React.useCallback(()=>{
        setIsModalOpen(true);
    }, []);
    const onModalClose = React.useCallback(()=>setIsModalOpen(false)
    , []);
    if (!modalBodySlot) {
        return null;
    }
    const footer = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('installments.modal.buttonText'),
        onClick: onModalClose,
        "data-t": "promote-installments-modal-button",
        size: "large"
    }), /*#__PURE__*/ React.createElement(Hr, {
        className: "promote-installments-modal__horizontal-rule"
    }), /*#__PURE__*/ React.createElement("p", {
        className: "promote-installments-modal__footer-text"
    }, /*#__PURE__*/ React.createElement("small", null, getFormattedLabel('installments.modal.footerText', {
        parseLink: true
    }))));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconTrigger, {
        onClick: onModalOpen,
        name: "learn-more",
        "aria-label": getLabel('installments.screenreader.modalToggle', {
            hideLabelKey: true
        })
    }), /*#__PURE__*/ React.createElement(Modal, {
        className: "promote-installments-modal",
        isOpen: isModalOpen,
        onModalClose: onModalClose,
        showIcon: true,
        title: getLabel('installments.modal.title'),
        footer: footer
    }, modalBodySlot));
};

export { PromoteInstallmentsModal as default };
//# sourceMappingURL=PromoteInstallmentsModal.js.map
